import { render, staticRenderFns } from "./main-lawyer.vue?vue&type=template&id=d62230ac&scoped=true&"
import script from "./main-lawyer.vue?vue&type=script&lang=js&"
export * from "./main-lawyer.vue?vue&type=script&lang=js&"
import style0 from "./main-lawyer.vue?vue&type=style&index=0&id=d62230ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62230ac",
  null
  
)

export default component.exports